import React, {createContext, useReducer} from 'react'

export const SET_CONNECTOR_LIST = 'SET_CONNECTOR_LIST'
export const SELECT_CONNECTOR = 'SELECT_CONNECTOR'
export const SET_SHOW_CONNECTOR_POPUP = 'SET_SHOW_CONNECTOR_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_CONNECTOR_LIST:
      return { ...data, connector_list: payload.data }
    case SELECT_CONNECTOR:
      return {
        ...data,
        selected_connector: payload.data.selected_connector,
        show_connector_popup: payload.data.show_connector_popup,
      }
    case SET_SHOW_CONNECTOR_POPUP:
      return {
        ...data,
        show_connector_popup: payload.data,
        selected_connector: payload.data ? data.selected_connector : {},
      }
    default:
      return data
  }
}

const initialState = {
  connector_list: [],
  selected_connector: {},
  show_connector_popup: false,
}

const ConnectorStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ConnectorContext.Provider value={[state, dispatch]}>
      {children}
    </ConnectorContext.Provider>
  )
}

export const ConnectorContext = createContext(initialState)
export default ConnectorStore
